import { mapActions } from 'vuex'
import powerbimixin from '@/mixin/powerbi'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

export default {
  props: ['name', 'opendialog'],

  data () {
    return {
      loading: false,
      isMiniMenu: true
    }
  },

  mixins: [powerbimixin],

  mounted () {
    this.loading = true

    this.getDashboardClientEmbedded(encodeURIComponent(this.name))
      .then(response => {
        this.loading = false
        this.loadDashboard(response.EmbedUrl, response.EmbedToken)
      }).catch(() => {
        this.loading = false
        this.addToast({
          text: 'Não foi possível carregar o Dashboard',
          type: 'danger'
        })
      })
  },

  methods: {
    ...mapActions([
      'getDashboardClientEmbedded'
    ]),

    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),

    close () {
      this.$emit('emit-close')
    }
  }
}
